/*
import HTMLEditor from './HTMLEditor';
export default class AutoDataPrefixer
{
  static apply( source:string )
  {
    let singleReplaceRegex = /\[\s*-/g;
    source = source.replace( singleReplaceRegex, "[data-" );
    let autoDataExtensionRegex = /\[(?!data-|([a-zA-Z0-9]+s*(\=|\~|\||\^|\$|\*|\])))/g;

    let appliedPrefixer = source.replace( autoDataExtensionRegex, "[data-" );

    return appliedPrefixer;
  }

  static applyAttribute( source:string )
  {
    source = source.replace( /^\s*\-/, "data-" );

    if ( /\-/.test( source ) && ! /^data\-/.test( source ) )
    {
      source = "data-" + source.replace( /^\s* /, "" );
    }

    return source;
  }

  static $( element:Element, selector:string ):Element
  {
    return element.querySelector( AutoDataPrefixer.apply( selector ) );
  }

  static $$( element:Element, selector:string):Element[]
  {
    let list = element.querySelectorAll( AutoDataPrefixer.apply( selector ) );
    return HTMLEditor.nodeListToArray( list ); 
  }

  static bind$( element:Element)
  {
    return ( selector:string ) => { return AutoDataPrefixer.$( element, selector ); }
  }

  static bind$$( element:Element, selector:string)
  {
    return ( selector:string ) => { return AutoDataPrefixer.$$( element, selector ); }
  }

  static setAttribute( element:Element, name:string, value:any )
  {
    name = AutoDataPrefixer.applyAttribute( name );
    element.setAttribute( name, value + "" );
  }

  static flagAttribute( element:Element, name:string, flag:boolean )
  {
    name = AutoDataPrefixer.applyAttribute( name );

    if ( flag )
    {
      element.setAttribute( name, "" );
    }
    else
    {
      element.removeAttribute( name );
    }
  }



}
*/

import { HTMLEditor } from "./HTMLEditor";

export class AutoDataPrefixer 
{
  static apply( source:string ) 
  {
    let singleReplaceRegex = /\[\s*-/g;
    source = source.replace(singleReplaceRegex, "[data-");
    let autoDataExtensionRegex = /\[(?!data-|([a-zA-Z0-9]+s*(\=|\~|\||\^|\$|\*|\])))/g;
    return source.replace( autoDataExtensionRegex, "[data-" );
  }

  static applyForAttributeName( name:string )
  {
    if ( name.indexOf( "-" ) === -1 )
    {
      return name;
    }

    if ( /^\-/.test( name ) ) 
    {
      return "data" + name;
    }

    if ( /^data-/.test( name ) )
    {
      return name;
    }

    return "data-" + name;
  }


  static flagAttribute( element:Element, name:string, flag:boolean )
  {
    name = AutoDataPrefixer.applyAttribute( name );

    if ( flag )
    {
      element.setAttribute( name, "" );
    }
    else
    {
      element.removeAttribute( name );
    }
  }

  static applyAttribute( source:string )
  {
    source = source.replace( /^\s*\-/, "data-" );

    if ( /\-/.test( source ) && ! /^data\-/.test( source ) )
    {
      source = "data-" + source.replace( /^\s* /, "" );
    }

    return source;
  }


  static getAttribute( element:Element, name:string )
  {
    let attributeName = AutoDataPrefixer.applyForAttributeName( name );
    //console.log( "get:", name," > ", attributeName );
    return element.getAttribute( attributeName );
  }

  static setAttribute( element:Element, name:string, value:string )
  {
    let attributeName = AutoDataPrefixer.applyForAttributeName( name );
    //console.log( "get:", name," > ", attributeName );
    return element.setAttribute( attributeName, value );
  }

  static $( element:Element, selector:string ) 
  {
    return element.querySelector( AutoDataPrefixer.apply( selector ) );
  }

  static $$( element:Element|Document, selector:string ) 
  {
    let list = element.querySelectorAll( AutoDataPrefixer.apply( selector ) );

    return HTMLEditor.nodeListToArray( list );
  }

  static bind$( element:Element ) 
  {
    return ( selector:string ) => { return AutoDataPrefixer.$( element, selector ); };
  }

  static bind$$( element:Element, selector:string) 
  {
    return ( selector:string ) => { return AutoDataPrefixer.$$( element, selector ); };
  }
}